import type { Article } from '../types';

/**
 * Title/category match for an article, case-insensitive.
 *
 * Articles have no Algolia index, so every article search in the admin is a
 * local filter over the whole collection. Kept here rather than in either
 * caller so the entity-link picker and the curated-collection article picker
 * agree on what "matches" means — a curator who finds an article in one should
 * find it in the other.
 */
export function filterArticleList(
  articles: Article[],
  term: string,
): Article[] {
  const q = term.trim().toLowerCase();
  if (!q) return articles;
  return articles.filter(
    (a) =>
      (a.title || '').toLowerCase().includes(q) ||
      (a.category || '').toLowerCase().includes(q),
  );
}
